export default __webpack_public_path__ + "static/media/1436.71be81c6.png";